const MAX_KEPT = 200

const initialState = {
	items: [],
	lastSeenId: 0,
	unreadCount: 0,
}

const posNotifications = function (state = initialState, action) {
	switch (action.type) {
		case 'ADD_POS_NOTIFICATIONS': {
			const incoming = action.payload || []
			if (incoming.length === 0) return state
			const maxId = incoming.reduce((m, n) => (n.id > m ? n.id : m), state.lastSeenId)
			const merged = [...incoming, ...state.items].slice(0, MAX_KEPT)
			return {
				...state,
				items: merged,
				lastSeenId: maxId,
				unreadCount: state.unreadCount + incoming.length,
			}
		}
		case 'MARK_POS_NOTIFICATIONS_READ': {
			const ids = action.payload || []
			if (ids.length === 0) return state
			const idSet = new Set(ids)
			const items = state.items.map(n => idSet.has(n.id) ? { ...n, read: true } : n)
			const unreadCount = Math.max(0, state.unreadCount - ids.length)
			return { ...state, items, unreadCount }
		}
		case 'SET_POS_NOTIFICATIONS_UNREAD_COUNT':
			return { ...state, unreadCount: action.payload || 0 }
		case 'RESET_POS_NOTIFICATIONS':
			return initialState
		default:
			return state
	}
}

export default posNotifications
